var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center justify-center rounded-full text-gray-900 bg-inherit hover:bg-gray-500 hover:text-white w-7 h-7",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"fill-current",attrs:{"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }